import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getProjectInfoStatus } from './utils/form';
export default {
  name: 'QuotationTab',
  props: {
    formData: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'add'
    },
    projectStatus: {
      type: [String, Number],
      default: null
    },
    quotationCardTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    quotationBusinessTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isTaskFormDisabled: {
      type: Function,
      required: true
    },
    isEditingTask: {
      type: Function,
      required: true
    },
    isViewTaskDisabled: {
      type: Function,
      required: true
    },
    changeQuotationBusinessType: {
      type: Function,
      required: true
    }
  },
  computed: {
    isCreateFlow: function isCreateFlow() {
      return ['add', 'projectReview'].includes(this.type);
    },
    quotationApproverRecords: function quotationApproverRecords() {
      var _this$formData$items, _this$formData$items$;
      var list = (_this$formData$items = this.formData.items) === null || _this$formData$items === void 0 ? void 0 : (_this$formData$items$ = _this$formData$items.quotation) === null || _this$formData$items$ === void 0 ? void 0 : _this$formData$items$.approver;
      return Array.isArray(list) ? list : [];
    },
    currentQuotationApproverType: function currentQuotationApproverType() {
      if (this.type !== 'approve') return null;
      var record = this.quotationApproverRecords.find(function (item) {
        return String(item.status) === '1';
      });
      return record ? String(record.type) : null;
    },
    showQuotationCommissionFields: function showQuotationCommissionFields() {
      if (this.type === 'approve') return true;
      if (this.isCreateFlow) return false;
      var quotation = this.formData.items.quotation || {};
      return ['accounting_method', 'commission', 'performance'].some(function (key) {
        return quotation[key] !== '' && quotation[key] != null;
      });
    },
    showQuotationCustomerNature: function showQuotationCustomerNature() {
      return this.formData.customer_nature !== '' && this.projectInfoStatus() !== 100;
    },
    showQuotationTimeLimit: function showQuotationTimeLimit() {
      return ['approve', 'view'].includes(this.type);
    },
    showQuotationManagerRemarks: function showQuotationManagerRemarks() {
      return Number(this.formData.items.quotation.task_status) > 1 || this.quotationApproverRecords.some(function (item) {
        return String(item.type) == '1' && Number(item.status) == 1;
      });
    },
    showQuotationVpRemarks: function showQuotationVpRemarks() {
      return Number(this.formData.items.quotation.task_status) > 1 || this.quotationApproverRecords.some(function (item) {
        return String(item.type) == '2' && Number(item.status) == 1;
      });
    }
  },
  methods: {
    projectInfoStatus: function projectInfoStatus() {
      return getProjectInfoStatus(this.projectStatus, this.formData);
    },
    handleQuotationAmountInput: function handleQuotationAmountInput(field) {
      var maxDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var maxIntegerDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 9;
      var raw = String(this.formData.items.quotation[field] || '');
      var cleaned = raw.replace(/[^\d.]/g, '');
      var dotIndex = cleaned.indexOf('.');
      var integerPart = '';
      var decimalPart = '';
      if (dotIndex === -1) {
        integerPart = cleaned;
      } else {
        integerPart = cleaned.slice(0, dotIndex);
        decimalPart = cleaned.slice(dotIndex + 1).replace(/\./g, '');
      }
      integerPart = integerPart.slice(0, maxIntegerDigits);
      decimalPart = decimalPart.slice(0, maxDecimals);
      var nextValue = integerPart;
      if (dotIndex !== -1) {
        nextValue = "".concat(integerPart, ".").concat(decimalPart);
      }
      this.formData.items.quotation[field] = nextValue;
    },
    handleQuotationNumberInput: function handleQuotationNumberInput() {
      this.formData.items.quotation.number = String(this.formData.items.quotation.number || '').replace(/[^\d]/g, '');
    },
    calcQuotationBudget: function calcQuotationBudget() {
      var _this$formData$items$2 = this.formData.items.quotation,
        money = _this$formData$items$2.money,
        number = _this$formData$items$2.number;
      if (money === '' || number === '' || Number(number) <= 0) return;
      this.formData.items.quotation.budget = (Number(money) / Number(number)).toFixed(2);
    },
    calcQuotationMoney: function calcQuotationMoney() {
      var _this$formData$items$3 = this.formData.items.quotation,
        budget = _this$formData$items$3.budget,
        number = _this$formData$items$3.number;
      if (budget === '' || number === '' || Number(number) <= 0) return;
      this.formData.items.quotation.money = (Number(budget) * Number(number)).toFixed(2);
    }
  }
};